module.exports = __webpack_public_path__ + "static/media/tranquil_living_4.bacb8e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/tranquil_living_4.jpg
// module id = 532
// module chunks = 0